import { createAPI } from '../../composable/useAPI';

export const useProductBOMAPI = () =>{
  const api = createAPI();

  const request = {
    productBOM:{
      get: async (params) => {
        return await api.get('/api/v2/product_bom', { params })
          .then((res) => { return res.data.data})
          .catch (err => {return false})
      },

      post: async (data) => {
        return await api.post('/api/v2/product_bom', data)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      },

      put: async (data) => {
          return await api.put('/api/v2/product_bom', data)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      },

      delete: async(params) => {
        const queryString = params.map((seq) => `productBOMSeq=${seq}`).join('&');
          return await api.delete(`/api/v2/product_bom?${queryString}`)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      }
    }
  };

  return {
    ...request
  };
}
